import styles from "../../Styles/dashboard.module.css";
import { Button, useMediaQuery } from "@mui/material";
import MainTable from "../../Components/GenericComponents/MainTable";
import { urlEnum } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useState } from "react";
import FgoMainPage, { FgoFormData } from "./FgoMainPage";
import { Download, Edit, Sync } from "@mui/icons-material";
import { toast } from "react-toastify";
import { updateData } from "../../Services/updateData";

export default function Fgo() {
  const phoneStyle = useMediaQuery("(max-width: 800px)");
  const [editItem, setEditItem] = useState<FgoFormData | null>(null);
  const [open, setOpen] = useState(false);
  const [shouldUpdate, setShouldUpdate] = useState(false);

  const header = [
    {
      label: Vocabulary.fgoInvoiceNumber,
      name: "fgoInvoiceNr",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.text,
      name: "Text",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.currency,
      name: "Valuta",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.invoiceType,
      name: "TipFactura",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.createdDate,
      name: "DataEmitere",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.payDate,
      name: "DataScadenta",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.vatAtCharge,
      name: "TvaLaIncasare",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          return <>{value ? Vocabulary.yes : Vocabulary.no}</>;
        },
      },
    },
    {
      label: Vocabulary.series,
      name: "Serie",
      options: {
        sort: false,
      },
    },
  ];
  function handleEdit(item: FgoFormData | null) {
    setShouldUpdate(false);
    setOpen(true);
    setEditItem(item);
  }
  function onClose() {
    setOpen(false);
  }

  async function handleSync() {
    try {
      await updateData(`${urlEnum.fgo}/sync`);
      if (!shouldUpdate) {
        setShouldUpdate(false);
      }
      setShouldUpdate(true);
    } catch (error) {
      toast.error(`${error}`);
    }
  }

  return (
    <div
      className={phoneStyle ? styles.mainContainerMobile : styles.mainContainer}
    >
      <MainTable
        urlEnumApi={urlEnum.fgo}
        header={header}
        tableTitle={Vocabulary.invoiceList}
        handleEdit={handleEdit}
        shouldUpdate={shouldUpdate}
        deleteMessages={{
          title: Vocabulary.deleteCategory,
          text: Vocabulary.deleteConfirmationCategory,
        }}
        hideOptionButtons={{
          edit: {
            condition: (item: any) => true,
          },
          delete: {
            condition: (item: any) => true,
          },
        }}
        anotherOptionButtons={[
          {
            condition: (item: any) => true,
            icon: <Download />,
            title: Vocabulary.download,
            action: (item: any) => {
              window.open(item.pdf);
            },
          },
          {
            condition: (item: any) => true,
            icon: <Edit />,
            title: Vocabulary.edit,
            action: (item: any) => {
              window.open("https://www.fgo.ro/facturi");
            },
          },
        ]}
        headerButtons={
          <Button
            style={{ marginLeft: 10 }}
            className={styles.addButtonTableHeader}
            onClick={() => {
              handleSync();
            }}
          >
            <Sync /> {Vocabulary.syncFgo}
          </Button>
        }
      />
      {open && (
        <FgoMainPage
          setShouldUpdate={setShouldUpdate}
          editItem={editItem}
          open={open}
          onClose={onClose}
        />
      )}
    </div>
  );
}
